import YourBarrioLogo from "@/components/brand/YourBarrioLogo";
import YourBarrioLoader from "@/components/ui/YourBarrioLoader";

export default function HomepageLoadingShell() {
  return (
    <main
      className="min-h-screen min-h-[100svh] bg-[#f6f7fb] text-[#18181b]"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading YourBarrio"
    >
      <section className="flex min-h-[360px] min-h-[100svh] items-center justify-center px-6 py-12">
        <div className="flex flex-col items-center gap-4 text-center">
          <YourBarrioLogo
            variant="wordmark-dark"
            alt="YourBarrio"
            width={182}
            height={36}
            priority
            className="h-auto w-[182px]"
          />
          <YourBarrioLoader size="md" className="text-[#411991]" />
          <span className="sr-only">Loading YourBarrio...</span>
        </div>
      </section>
    </main>
  );
}
